export default __webpack_public_path__ + "static/icon-52ea3acb9cf397f1f8e994344fe14a12.png";